<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORE_DETAILS.GENERAL_TAB_LABEL' | translate }}</h3>
    </div>

    <div class="sp-row__align">
      <h5 class="sp-color__primary sp-margin__right">{{ getStoreStatusLabel() | translate }}</h5>
      <div
        class="sp-circle__xs sp-margin__right"
        [matTooltip]="getStoreStatusLabel() | translate"
        [ngClass]="getStoreStatusBackgroundClass()"></div>
      <app-shared-store-logo
        size="m"
        [current_store_logo]="store?.logo_url"></app-shared-store-logo>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-store-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'STORES.ID_COLUMN_LABEL'"
      [content]="store?.store_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'STORES.REGISTRATION_DATE_LABEL'"
      [content]="(store?.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.NAME_LABEL'"
      [content]="getStoreName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.SALES_NETWORK_ID_LABEL'"
      [content]="store?.sales_network_id || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.PHONE_LABEL'"
      [content]="getFormattedPhone()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.EMAIL_LABEL'"
      [content]="store?.email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.WEBSITE_LABEL'"
      [content]="store?.website || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.VAT_LABEL'"
      [content]="store?.company_vat || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.COMPANY_LABEL'"
      [content]="getCompanyName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.CUSTOM_BUYER_SUBDOMAIN_LABEL'"
      [content]="store?.company_custom_buyer_subdomain || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'GENERAL.BIRTH_PLACE_LABEL'"
      [content]="getFormattedAddress()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
